// 数据概览
export const basicColumns = {
  name: 'tag',
  title: {
    name: '数据概览'
  },
  content: {
    colSpan: 4,
    list: [
      {
        field: 'schoolNum',
        label: '学校数',
        icon: require('@assets/img/home/home_icon_school@2x.png'),
        value: 0
      },
      {
        field: 'teacherNum',
        label: '老师数',
        icon: require('@assets/img/home/icon_teacher.png'),
        value: 0
      },
      {
        field: 'studentNum',
        label: '学生数',
        icon: require('@assets/img/home/icon_student.png'),
        value: 0
      },
      {
        field: 'productNum',
        label: '课程商品',
        icon: require('@assets/img/home/icon_lesson.png'),
        value: 0
      },
      {
        field: 'courseNum',
        label: '素质课程班',
        icon: require('@assets/img/home/icon_class.png'),
        value: 0
      },
      {
        field: 'daycareNum',
        label: '托管课程班',
        icon: require('@assets/img/home/icon_trusteeship.png'),
        value: 0
      }
    ]
  }
};

// 营收统计
export const revenueColumns = {
  name: 'revenue',
  title: {
    name: '营收统计'
  },
  content: {
    numInfo: {
      totalAmount: 0, // 总金额
      orderNum: 0, // 订单总笔数
      returnAmount: 0, // 退单额
      refundNum: 0 // 退订单数
    },
    chartData: {
      columns: ['日期', '总金额', '退单额'],
      rows: []
    }
  }
};

// 最受欢迎TOP5
export const top5Columns = {
  name: 'table',
  title: {
    name: '最受欢迎TOP5',
    leftControl: [
      {
        field: 'TableType',
        component: 'Tabs'
      }
    ]
  },
  content: {
    columns: [
      {
        title: '排名',
        type: 'index'
      },
      {
        title: '课程',
        key: 'classroomName'
      },
      {
        title: '所属分类',
        key: 'courseTypeName'
      },
      {
        title: '报名人数',
        key: 'enrollNum'
      }
    ],
    rows: []
  }
};

// 订餐统计
export const mealColumns = {
  name: 'pie',
  title: {
    name: '订餐统计',
    leftControl: [
      {
        field: 'FoodTime',
        component: 'DatePicker'
      }
    ]
  },
  content: {
    columns: ['schoolName', 'offerNum'],
    rows: []
  }
};

// 托管概览
export const tuoguanColumns = {
  name: 'tags',
  title: {
    name: '托管概览'
  },
  content: {
    colSpan: 24,
    tuoguanStyle: {
      height: '150px',
      marginRigth: '0px',
      padding: '38px 20px 20px 20px'
    },
    list: []
  },
  typeMap: {
    1: '早托',
    2: '午托',
    3: '晚托'
  }
};

// 课程概览
export const courseColumns = {
  name: 'tags',
  title: {
    name: '课程概览'
  },
  content: {
    colSpan: 8,
    list: [],
    tuoguanStyle: {
      height: '136px',
      marginRight: '20px',
      padding: '30px 20px'
    }
  },
  tableModal: {
    columns: [
      {
        title: '课程分类',
        key: 'courseTypeName'
      },
      {
        title: '课程数量',
        key: 'courseNumber'
      },
      {
        title: '开班数量',
        key: 'classNumber'
      },
      {
        title: '报名人数',
        key: 'signUpNumber'
      }
    ],
    rows: []
  }
};
